import React, { Component } from 'react';
import Keyboard from 'react-simple-keyboard';
import 'react-simple-keyboard/build/css/index.css';

var stringUtil = require('../../utils/string/stringUtil.js');
var rfidUtil = require('../../utils/rfid/rfidUtil.js');
var viewUtil = require('../../utils/view/viewUtil.js');
var translator = require('../../utils/translator/translator.js');

class LoginComponent extends Component 
{

    constructor(props) 
    {
        super(props);

        this.onChange = this.onChange.bind(this);
        this.onKeyPress = this.onKeyPress.bind(this);
        this.onKeyboardRef = this.onKeyboardRef.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);

        this.getFormattedPins = this.getFormattedPins.bind(this);

        this.state = 
        {
            layoutName: "default",
            formattedPins: "",
            pins: "",
            cardPins: "",
        };
    }

    onKeyboardRef(r)
    {
        this.keyboard = r;
    }

    onChange(input) 
    {
        this.keyboard.setInput("");
        if (!this.props.pinAllowed)
        {
            this.setState({});
            return;
        }

        this.state.pins = this.state.pins + "" + input;
        this.state.formattedPins = this.getFormattedPins();

        if (this.state.pins.length >= 3)
        {
            var staff = this.validateUser(true, this.state.pins);
            if (staff != null)
            {
                this.props.onLogin(true, staff);
                return;
            }
        }

        this.setState({});
    };

    onKeyPress(button) 
    {
        this.keyboard.setInput("");
        if (!this.props.pinAllowed)
        {
            this.setState({});
            return;
        }

        if (button === "{bksp}")
        {
            if (stringUtil.isStringNullOrEmpty(this.state.pins))
                return;

            this.state.pins = this.state.pins.substring(0, this.state.pins.length-1);
            this.state.formattedPins = this.getFormattedPins();
            this.setState({});
            return;
        }

        if (button === "{ok}")
        {
            if (this.state.pins.length <= 0)
                return;

            var staff = this.validateUser(true, this.state.pins);
            if (staff == null)
            {
                viewUtil.showErrorAlert(translator.getLabel("invalid_pin"));
                this.state.pins = "";
                this.state.formattedPins = this.getFormattedPins();
                this.setState({});
                return;
            }

            this.props.onLogin(true, staff);
            return;
        }
    };

    componentDidMount()
    {
        document.addEventListener("keydown", this.onKeyDown, false);
    }
    componentWillUnmount()
    {
        document.removeEventListener("keydown", this.onKeyDown, false);
        this.keyboard.destroy();
    }

    onKeyDown(event)
    {
        event.stopPropagation();
        
        if (event.keyCode == 13)
        {
            if (this.state.cardPins == null || this.state.cardPins.length <=0)
                return;

            var cardPins = this.state.cardPins;
            this.state.cardPins = "";
                
            if (this.props.onLogin)
            {
                cardPins = rfidUtil.mapSecurityCode(cardPins);

                var staff = this.validateUser(false, cardPins);
                if (staff == null)
                {
                    viewUtil.showErrorAlert(translator.getLabel("invalid_staff_card"));
                    this.state.pins = "";
                    this.state.formattedPins = this.getFormattedPins();
                    this.setState({});
                    return;
                }

                this.props.onLogin(false, staff);
                return;
            }
            
        }
        else
        {
            var isValid =    event.keyCode >= 65 && event.keyCode <= 90 ||   // A-Z
                        event.keyCode >= 96 && event.keyCode <= 105 ||  // a-z
                        event.keyCode >= 48 && event.keyCode <= 57 ||
                        event.keyCode == 32;     // Space

            if (isValid)
                this.state.cardPins = this.state.cardPins + "" + event.key;
            else
                this.state.cardPins = "";
        }
    }

    render() 
    {
        return (
            <table>
                    <tr>
                        <td>
                            <div style={{ display: "flex", flexFlow: "column nowrap", width: "100%", margin: '10px auto' }}>
                                <div className='primary-color' style={{ fontSize: "5vh", fontWeight: "bold", textAlign: "center", minHeight: "8vh"}}>{this.state.formattedPins}</div>
                                <div style={{ marginTop: "-10px" }}><hr className='primary-color'/></div>
                            </div>
                        </td>
                    </tr>

                    <tr>
                        <td>
                            <div>
                                <div>
                                    <Keyboard
                                    useMouseEvents={true}
                                        //modules={[swipe]}
                                        keyboardRef={this.onKeyboardRef}
                                        layoutName={this.state.layoutName}
                                        onChange={this.onChange}
                                        onKeyPress={this.onKeyPress}
                                        theme='hg-theme-default login-keyboard'
                                        
                                        display={
                                            {
                                                "{bksp}": "\u25C0",
                                                "{ok}": "\u2714",
                                            }
                                        }
                                        
                                        buttonTheme={[
                                            {
                                                class: "keyboard-login-digits",
                                                buttons: "0 1 2 3 4 5 6 7 8 9 {bksp} {ok}"
                                            },
                                        ]}

                                        layout={{
                                            default: ["1 2 3", "4 5 6", "7 8 9", "{bksp} 0 {ok}"],
                                        }}
                                        >
                                    </Keyboard>
                                </div>
                            </div>
                        </td>
                    </tr>

                </table>);
    }

    getFormattedPins()
    {
        var characters = [];

        for (var i = 0; i < this.state.pins.length; i++) 
        {
            characters.push('*')
        }

        return characters.join("  ");
    }

    validateUser(isPin, code)
    {
        
        var staff = null;

        if (isPin)
            staff = this.props.staffs.find(s => s.pinCode == code);
        else
            staff = this.props.staffs.find(s => s.securityCardNumber == code);

        return staff;
    }
}

export default LoginComponent;